import { Button, Input, Modal } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useMessage } from "../../../../Components/MessageProvider/MessageProvider";
import axiosInstance from "../../../../Components/axiosInstance/AxiosInstance";
import TextArea from "antd/es/input/TextArea";

export default function ViewAmmafos({
  isModalOpen,
  setIsModalOpen,
  getData,
  id,
}) {
  let [data, setData] = useState({
    ticket: {
      date: null,
      ticket: null,
    },
    believer: {
      id: null,
      name: null,
      date: null,
    },
    ykx: {
      date: null,
      ykx: null,
    },
    habarnoma: {
      id: null,
      date: null,
    },
    name: null,
    organization: "Омбор",
    INN: null,
    product: "Аммофос",
    price: null,
    comment: null,
    tonna: null,
  });

  let [loading, setLoading] = useState(false);
  const messageApi = useMessage();

  const inputRefs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
  ];

  const handleKeyDown = (e, index) => {
    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      // Prevent date value from changing
      if (e.target.type === "date") {
        e.preventDefault();
      }
      if (e.key === "ArrowDown") {
        // Focus the next input (if it exists)
        if (index < inputRefs.length - 1) {
          inputRefs[index + 1].current.focus();
        }
      } else if (e.key === "ArrowUp") {
        // Focus the previous input (if it exists)
        if (index > 0) {
          inputRefs[index - 1].current.focus();
        }
      }
    }
  };

  let uploadData = async () => {
    try {
      setLoading(true);

      let { data: info } = await axiosInstance.put(
        "/api/chiqim-official/ammafos-kaliy/" + id,
        {
          ...data,
        }
      );
      if (info.success) {
        console.log("data");
        console.log(info);
        setData(data);
        getData();
        setIsModalOpen(false);
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleConnection = async (value) => {
    try {
      let { data: info } = await axiosInstance.get(
        "/api/chiqim-official/chirchiq/" + id
      );
      console.log(info);
      if (info.success) {
        setData({
          ticket: {
            date: info?.data?.ticket?.date,
            ticket: info?.data?.ticket?.ticket,
          },
          believer: {
            id: info?.data?.believer?.id,
            name: info?.data?.believer?.name,
            date: info?.data?.believer?.date,
          },
          ykx: {
            date: info?.data?.ykx?.date,
            ykx: info?.data?.ykx?.ykx,
          },
          habarnoma: {
            id: info?.data?.habarnoma?.id,
            date: info?.data?.habarnoma?.date,
          },
          name: info?.data?.name,
          organization: info?.data?.organization,
          INN: info?.data?.INN,
          product: info?.data?.product,
          price: info?.data?.price,
          tonna: info?.data?.tonna,
          comment: info?.data?.comment,
        });
        // setIsModalOpen(false);
      }
      console.log(info);
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
    }
  };

  useEffect(() => {
    if (isModalOpen) {
      handleConnection();
    }
  }, [isModalOpen]);

  return (
    <Modal
      style={{ top: "10px" }}
      title="Ticketni o'qgartirish"
      open={isModalOpen}
      loading={data ? false : true}
      onOk={() => {
        setIsModalOpen(false);
      }}
      onCancel={() => {
        console.log("Modal closed via Cancel button or close icon.");
        setIsModalOpen(false);
      }}
      footer={[]}
    >
      {/* <p className="text-[14px] text-[#111827] p-0 m-0 col-span-2">yozdi</p> */}
      <div>
        <label className="text-[16px] ">Tshkilot / Korxona</label>
        <Input
          type="text"
          placeholder="Tshkilot / Korxona"
          value={data.organization}
          ref={inputRefs[2]}
          disabled={true}
          onKeyDown={(e) => {
            handleKeyDown(e, 2);
          }}
          onChange={(e) => {
            setData({
              ...data,
              organization: e.target.value,
            });
          }}
        />
        <div className="bg-[#bfbfbf] p-2 rounded-lg">
          <label className="text-[16px] block ">ЎзРТХБ шартномаси </label>
          <label className="text-[12px] ">Ticket Sana</label>
          <Input
            type="date"
            placeholder="time"
            disabled={true}
            value={data?.ticket?.date?.split("T")[0]}
            ref={inputRefs[0]}
            onKeyDown={(e) => {
              handleKeyDown(e, 0);
              if (e.key === "F2") {
                const currentDate = new Date().toISOString(); // Get current date in YYYY-MM-DD format
                setData({
                  ...data,
                  ticket: { ...data.ticket, date: currentDate },
                });
              }
            }}
            onChange={(e) => {
              console.log(e.target.value);
              setData({
                ...data,
                ticket: { ...data.ticket, date: e.target.value },
              });
            }}
          />
          <label className="text-[12px] ">Ticket raqami</label>
          <Input
            type="text"
            placeholder="Ticket raqami"
            autoFocus={true}
            value={data.ticket.ticket}
            disabled={true}
            ref={inputRefs[1]}
            onKeyDown={(e) => {
              handleKeyDown(e, 1);
            }}
            onChange={(e) => {
              setData({
                ...data,
                ticket: { ...data.ticket, ticket: e.target.value },
              });
            }}
          />
        </div>

        <div className="bg-[#bfbfbf] p-2 rounded-lg mt-1">
          <label className="text-[16px] block ">ХАБАРНОМА </label>
          <label className="text-[12px] ">Санаси</label>
          <Input
            type="date"
            placeholder="Санаси"
            value={data?.habarnoma?.date?.split("T")[0]}
            ref={inputRefs[0]}
            disabled={true}
            onKeyDown={(e) => {
              handleKeyDown(e, 0);
              if (e.key === "F2") {
                const currentDate = new Date().toISOString().split("T")[0]; // Get current date in YYYY-MM-DD format
                setData({
                  ...data,
                  habarnoma: { ...data.habarnoma, date: currentDate },
                });
                console.log("Date set to:", currentDate);
              }
            }}
            onChange={(e) => {
              console.log(e.target.value);
              setData({
                ...data,
                habarnoma: { ...data.habarnoma, date: e.target.value },
              });
            }}
          />
          <label className="text-[12px] ">Раками</label>
          <Input
            type="text"
            placeholder="Раками"
            autoFocus={true}
            disabled={true}
            value={data.habarnoma.id}
            ref={inputRefs[1]}
            onKeyDown={(e) => {
              handleKeyDown(e, 1);
            }}
            onChange={(e) => {
              // console.log(e.target.value.split("\t"));
              setData({
                ...data,
                habarnoma: { ...data.habarnoma, id: e.target.value },
              });
            }}
          />
        </div>
        <label className="text-[16px] ">Klient</label>
        <Input
          type="text"
          placeholder="Klient nomi"
          value={data.name}
          disabled={true}
          ref={inputRefs[2]}
          onKeyDown={(e) => {
            handleKeyDown(e, 2);
          }}
          onChange={(e) => {
            setData({
              ...data,
              name: e.target.value,
            });
          }}
        />
        <label className="text-[16px] ">INN</label>
        <Input
          type="text"
          placeholder="INN"
          value={data.INN}
          disabled={true}
          ref={inputRefs[3]}
          onKeyDown={(e) => {
            handleKeyDown(e, 3);
          }}
          onChange={(e) => {
            setData({
              ...data,
              INN: e.target.value,
            });
          }}
        />
        <label className="text-[16px] ">Ichonchnoma nomeri</label>
        <Input
          type="text"
          placeholder="Ishonchnoma raqami"
          value={data.believer.id}
          disabled={true}
          ref={inputRefs[4]}
          onKeyDown={(e) => {
            handleKeyDown(e, 4);
          }}
          onChange={(e) => {
            setData({
              ...data,
              believer: { ...data.believer, id: e.target.value },
            });
          }}
        />
        <label className="text-[16px] ">Ichonchli shaxs</label>
        <Input
          type="text"
          placeholder="Shaxs"
          value={data.believer.name}
          disabled={true}
          ref={inputRefs[5]}
          onKeyDown={(e) => {
            handleKeyDown(e, 5);
          }}
          onChange={(e) => {
            setData({
              ...data,
              believer: { ...data.believer, name: e.target.value },
            });
          }}
        />
        <label className="text-[12px] ">Ichonoma sanasi</label>
        <Input
          type="date"
          placeholder="Yukxati sanasi"
          value={data.believer.date?.split("T")[0]}
          disabled={true}
          ref={inputRefs[6]}
          onKeyDown={(e) => {
            handleKeyDown(e, 6);
            if (e.key === "F2") {
              const currentDate = new Date().toISOString().split("T")[0]; // Get current date in YYYY-MM-DD format
              setData({
                ...data,
                believer: { ...data.believer, date: currentDate },
              });
              console.log("Date set to:", currentDate);
            }
          }}
          onChange={(e) => {
            setData({
              ...data,
              believer: { ...data.believer, date: e.target.value },
            });
          }}
        />
        <div className="bg-[#bfbfbf] p-2 rounded-lg mt-2">
          <label className="text-[16px] block ">
            Махсулот транспорт юк хати{" "}
          </label>
          <label className="text-[12px] ">Yukxati sanasi</label>
          <Input
            type="date"
            placeholder="Yukxati sanasi"
            value={data.ykx.date?.split("T")[0]}
            disabled={true}
            ref={inputRefs[6]}
            onKeyDown={(e) => {
              handleKeyDown(e, 6);
              if (e.key === "F2") {
                const currentDate = new Date().toISOString(); // Get current date in YYYY-MM-DD format
                setData({
                  ...data,
                  ykx: { ...data.ykx, date: currentDate },
                });
                console.log("Date set to:", currentDate);
              }
            }}
            onChange={(e) => {
              setData({
                ...data,
                ykx: { ...data.ykx, date: e.target.value },
              });
            }}
          />
          <label className="text-[12px] ">Yukxati raqami</label>
          <Input
            type="text"
            placeholder="Yukxati raqami"
            value={data.ykx.ykx}
            disabled={true}
            ref={inputRefs[7]}
            onKeyDown={(e) => {
              handleKeyDown(e, 7);
            }}
            onChange={(e) => {
              setData({
                ...data,
                ykx: { ...data.ykx, ykx: e.target.value },
              });
            }}
          />
        </div>
        <label className="text-[16px] ">Yuk nomi</label>
        <Input
          type="text"
          placeholder="Yukxati raqami"
          value={data.product}
          disabled={true}
          ref={inputRefs[8]}
          onKeyDown={(e) => {
            handleKeyDown(e, 8);
          }}
          onChange={(e) => {
            setData({
              ...data,
              product: e.target.value,
            });
          }}
        />
        <label className="text-[16px] ">Yuk Tonnasi</label>
        <Input
          type="text"
          placeholder="Yuk Tonnasi"
          value={data.tonna}
          disabled={true}
          ref={inputRefs[9]}
          onKeyDown={(e) => {
            handleKeyDown(e, 9);
          }}
          onChange={(e) => {
            setData({
              ...data,
              tonna: e.target.value,
            });
          }}
        />
        <label className="text-[16px] ">Yuk Qiymati</label>
        <Input
          type="text"
          placeholder="Yuk Qiymati"
          value={data.price}
          disabled={true}
          ref={inputRefs[10]}
          onKeyDown={(e) => {
            handleKeyDown(e, 10);
          }}
          onChange={(e) => {
            setData({
              ...data,
              price: e.target.value,
            });
          }}
        />
        <label className="text-[16px] ">Izoh</label>
        <TextArea
          rows={4}
          placeholder="Type your text here..."
          value={data.comment}
          disabled={true}
          ref={inputRefs[13]}
          onKeyDown={(e) => {
            handleKeyDown(e, 13);
          }}
          onChange={(e) => {
            setData({
              ...data,
              comment: e.target.value,
            });
          }}
        />
      </div>
    </Modal>
  );
}
